import AddCaseForm from "../../Components/AddCaseForm/AddCaseForm";
import AddCaseForm2 from "../../Components/AddCaseForm/AddCaseForm2";
import Header from "../../Components/Header/Header";
import AddCaseForm3 from "../../Components/AddCaseForm/AddCaseForm3"

function AddCasePage() {
    return (
        <div className="">
            <Header />
            <AddCaseForm3 />
        </div>
    )
}

export default AddCasePage;